import React from "react";
import { View, Text, TextInput, Button } from "ui";
import { styled } from "styles";
import braintree from "braintree-web";
import { notify } from "../shared/services/notify";
import { DataProps } from "types";
import { subscriptionMutations } from "api";
import { RouteComponentProps } from "react-router";

export default class Payment extends React.Component<
  DataProps & RouteComponentProps<any>
> {
  public instance: any;
  public componentDidMount() {
    braintree.client.create(
      {
        authorization: this.props.currentUser.clientToken
      },
      (clientErr, clientInstance) => {
        if (clientErr) {
          console.error(clientErr);
          return;
        }
        braintree.hostedFields.create(
          {
            client: clientInstance,
            styles: {
              input: {
                "font-size": "14px",
                "font-weight": "bold"
              },
              "input.invalid": {
                color: "red"
              },
              "input.valid": {
                color: "green"
              }
            },
            fields: {
              number: {
                selector: "#card-number",
                placeholder: "0000 1111 2222 3333"
              },
              cvv: {
                selector: "#cvv",
                placeholder: "123"
              },
              expirationDate: {
                selector: "#expiration-date",
                placeholder: "10/22"
              }
            }
          },
          (err, instance) => {
            if (err) {
              console.error(err);
              return;
            }
            this.instance = instance;
          }
        );
      }
    );
  }

  public render = () => {
    return (
      <View flexDirection="column" pl={2} pr={2}>
        <Text fontSize={4} mb={2} fontWeight="bold">Plata 60 lei</Text>
        <Text fontSize={2}>NUMAR CARD </Text>
        <Input id="card-number" className="hosted-field" />
        <View flexDirection="row" flexWrap="wrap">
          <View flex={3} flexDirection="column">
            <Text fontSize={2}> DATA DE EXPIRARE </Text>
            <Input id="expiration-date" className="hosted-field" />
          </View>
          <View flex={1} ml={1} flexDirection="column">
            <Text fontSize={2}> COD CVV</Text>
            <Input id="cvv" className="hosted-field" />
          </View>
        </View>
        <Text fontSize={2}>NUMELE DE PE CARD </Text>
        <NameInput mt={1} mb={1} placeholder="Nume detinator card" />
        <subscriptionMutations.Subscribe>
          {subscribe => (
            <Button
              mt={2}
              onClick={async () => {
                this.instance.tokenize(async (err, payload) => {
                  if (err) {
                    notify("Datele cardului nu sunt valide.");
                    return;
                  }

                  await subscribe({
                    variables: {
                      nonce: payload.nonce
                    }
                  });

                  this.props.history.push({
                    pathname: "/app/abonament",
                    search: 'payment',
                  });
                });
                
              }}
            >
              <Text color="white" fontSize={5}>
                Confirma Plata
              </Text>
            </Button>
          )}
        </subscriptionMutations.Subscribe>
      </View>
    );
  }
}

const NameInput = styled(TextInput)`
  background-color: transparent;
  font-weight: bold;
  height: 40px;
  padding: 0;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 10px;
  border: 1px solid black;
`;
const Input = styled.div`
  margin-bottom: 15px;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 10px;
  height: 40px;
  border: 1px solid black;
`;



// WEBPACK FOOTER //
// ./src/pages/Payment.tsx